import { render, staticRenderFns } from "./modal-actions.vue?vue&type=template&id=f3315bd2&scoped=true&"
import script from "./modal-actions.vue?vue&type=script&lang=js&"
export * from "./modal-actions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3315bd2",
  null
  
)

export default component.exports